module.exports = __webpack_public_path__ + "5769e3d863031a5732390cd023ac32a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-29.png
// module id = 2709
// module chunks = 0